import { useState, Suspense, lazy } from "react";

// @mui
import {
  Stack,
  Box,
  Tooltip,
  IconButton,
  Avatar,
  Typography,
} from "@mui/material";
//import LoadingButton from "@mui/lab/LoadingButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChalkboard } from "@fortawesome/pro-solid-svg-icons";
import { faClone } from "@fortawesome/pro-regular-svg-icons";
import useCurrentPath from "../../hooks/useCurrentPath";
// hooks
// routes

//import { useSnackbar } from "notistack";

// components
import Iconify from "../../components/Iconify";
//
import ShareDialog from "./ViewerShareDialog.js";
import { fDate } from "../../utils/formatTime";
import Helper from "../../playcreator/functions/Helper.js";
import TeamAvatar from "../../components/TeamAvatar";

var canUseDOM = !!(
  typeof window !== "undefined" &&
  window.document &&
  window.document.createElement
);

const ErrorThrower = () => {
  if (!canUseDOM) {
    throw new Error("Component can only be rendered in the browser");
  }
};
const Loadable = (Component) => (props) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks

  return (
    <Suspense fallback={<div></div>}>
      <ErrorThrower />
      <Component {...props} />
    </Suspense>
  );
};

const PlayPrintPreview = Loadable(
  lazy(() => import("../../components/PlayPrintPreviewV2.js"), { ssr: false })
);

// ----------------------------------------------------------------------

export default function ViewerPlayToolbar(props) {
  //const { enqueueSnackbar } = useSnackbar();
  let { play, code } = props;

  const [showShareDialog, setShowShareDialog] = useState(false);
  const [showPrintPreview, setShowPrintPreview] = useState(false);
  const currentPath = useCurrentPath();
  return (
    <>
      {play && showShareDialog && (
        <ShareDialog
          shareableLinkCode={code}
          phases={play.data.phases}
          settings={play.data.settings}
          dbData={play}
          open={showShareDialog}
          onClose={() => {
            setShowShareDialog(false);
          }}
        />
      )}

      <Stack
        spacing={2}
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ sm: "center" }}
        sx={{ mb: 0 }}
      >
        <Stack direction="row">
          {play.user_id && (
            <>
              {play.picture ? (
                <Avatar
                  sx={{ height: 48, width: 48 }}
                  alt={play.name}
                  src={play.picture}
                />
              ) : (
                <Avatar sx={{ height: 48, width: 48 }} />
              )}

              <Stack spacing={0} sx={{ ml: 2 }}>
                <Box sx={{ fontWeight: 500 }}>{play?.name ?? "Guest User"}</Box>
                <Box sx={{ color: "grey.600", fontSize: 14 }}>
                  {play.edit_date ? (
                    <Box>
                      Last edited{" "}
                      {fDate(Helper.getDateFromMysql(play?.edit_date))}
                    </Box>
                  ) : (
                    <Box>
                      Created{" "}
                      {play?.date && fDate(Helper.getDateFromMysql(play?.date))}
                    </Box>
                  )}
                </Box>
              </Stack>
            </>
          )}

          {play.team_id && (
            <>
              <TeamAvatar
                team={{ name: play.team_name, picture: play.team_picture }}
                sx={{ height: 48, width: 48 }}
              />

              <Stack spacing={0} sx={{ ml: 2 }}>
                <Box sx={{ fontWeight: 500 }}>{play?.team_name}</Box>
                <Box sx={{ color: "grey.600", fontSize: 14 }}>
                  {play.edit_date ? (
                    <Box>
                      Last edited{" "}
                      {fDate(Helper.getDateFromMysql(play?.edit_date))}
                    </Box>
                  ) : (
                    <Box>
                      Created{" "}
                      {play?.date && fDate(Helper.getDateFromMysql(play?.date))}
                    </Box>
                  )}
                </Box>
              </Stack>
            </>
          )}
        </Stack>
        <Stack direction="row" spacing={0.5}>
          <Tooltip title="Edit in PlayCreator">
            <IconButton
              href={`${process.env.REACT_APP_MARKETING_PAGE}/playcreator?code=${code}&utm_source=blog&utm_medium=viewer&utm_campaign=add_to_library&utm_content=${currentPath}&utm_term=${play.user_id}`}
            >
              <Box
                sx={{
                  width: 24,
                  height: 24,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FontAwesomeIcon style={{ fontSize: 18 }} icon={faChalkboard} />
              </Box>
            </IconButton>
          </Tooltip>

          <Tooltip title="Download PDF">
            <IconButton
              component="div"
              onClick={() => {
                setShowPrintPreview("download");
              }}
            >
              <Iconify icon={"eva:download-fill"} />
            </IconButton>
          </Tooltip>

          <Tooltip title="Print">
            <IconButton
              component="div"
              onClick={() => {
                setShowPrintPreview("print");
              }}
            >
              <Iconify icon={"eva:printer-fill"} />
            </IconButton>
          </Tooltip>

          <Tooltip title="Share">
            <IconButton
              component="div"
              onClick={() => setShowShareDialog(true)}
            >
              <Iconify icon={"eva:share-fill"} />
            </IconButton>
          </Tooltip>

          <Tooltip title="Add to your library">
            <IconButton
              href={`${process.env.REACT_APP_MARKETING_PAGE}/dashboard/plays?code=${code}&utm_source=blog&utm_medium=viewer&utm_campaign=add_to_library&utm_content=${currentPath}&utm_term=${play.user_id}`}
            >
              <Box
                sx={{
                  width: 24,
                  height: 24,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FontAwesomeIcon style={{ fontSize: 18 }} icon={faClone} />
              </Box>
            </IconButton>
          </Tooltip>
        </Stack>
      </Stack>
      {play && (
        <PlayPrintPreview
          play={play}
          button={showPrintPreview}
          open={showPrintPreview}
          onClose={() => {
            setShowPrintPreview(false);
          }}
        />
      )}
    </>
  );
}
